import { mitt } from '@flinks/utils';

export const linksEvent = mitt();

export enum LinksEventType {
  /**
   * 刷新页面
   */
  reloadPage = 'reloadPage',
  /**
   * 在线人数
   */
  onlineCount = 'onlineCount',
}
